import request from 'utils/request'

/**
 * 获取申请页详情
 * @param data
 * @returns {*}
 */

export const getPageInsCoverRate = data => {
  return request().post('customer/overview/pageInsCoverRate', data)
}
